module.exports = __webpack_public_path__ + "media/images/site/CINFANTIL_MUSICA_BRINQ-6e671f84d93d34e6591ff4ff97fcaba7.jpg";